import { ApiRoute } from 'api-base-refrence';
import { ApiApiRoute } from 'app/api-route/api/api.api';

export class CaslRuleApiRoute extends ApiRoute {
  static apiName = '/casl-rule';
  static parent = ApiApiRoute;
  static urlPattern() {
    return `${this.apiName}`;
  }
}
